// The SMS marketing consent checkbox, shared by every step that collects a
// phone number — the consent belongs beside the number it refers to, so it
// travels with the field.
//
// The value is `state.postBookingSmsOptIn` whichever step renders it, so the
// post-booking submit persists it unchanged (POST_BOOKING_FIELD is an open
// payload). Markets with their own consent copy supply it through
// CountryConfig.consent; absent that, the US TCPA wording renders.
//
// Callers decide WHETHER to show it: `smsOptInOffered` is false where the
// market sends no SMS (UK), and AU folds SMS into its single combined
// marketing box, so the separate checkbox is suppressed where
// `consent.combined` is set.

import styles from '../styles/widget.module.css';
import type { BookingAction, BookingState } from '../state/machine';
import { countryConfigOrDefault } from '../config/countries';

interface SmsOptInProps {
  state: BookingState;
  dispatch: React.Dispatch<BookingAction>;
}

export function SmsOptIn({ state, dispatch }: SmsOptInProps) {
  const { consent, privacyPolicyUrl } = countryConfigOrDefault(state.country);

  return (
    <label className={styles.checkboxRow}>
      <input
        type="checkbox"
        checked={state.postBookingSmsOptIn}
        onChange={(e) =>
          dispatch({
            type: 'POST_BOOKING_FIELD',
            payload: { postBookingSmsOptIn: e.target.checked },
          })
        }
      />
      <span>
        {consent ? (
          <>
            <strong className={styles.consentOptInLabel}>{consent.smsLabel}</strong>
            <span className={styles.consentOptInBody}>{consent.smsBody}</span>
          </>
        ) : (
          <>
            By checking the box, you consent to receive marketing text messages from
            Club Champion at the number provided, including messages sent by
            autodialer. Consent is not a condition of purchase. Msg frequency varies.
            Msg &amp; data rates may apply. Reply HELP for help. STOP to opt-out. See{' '}
            <a
              href={privacyPolicyUrl}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.classicGreenLink}
            >
              Privacy Policy
            </a>
            .
          </>
        )}
      </span>
    </label>
  );
}
